import { Component, ChangeDetectionStrategy, inject } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { MsalService } from "@azure/msal-angular";
import { ButtonModule } from "primeng/button";

@Component({
    selector: "app-account-no-companies",
    templateUrl: "./account-no-companies.component.html",
    styleUrl: "./account-no-companies.component.scss",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslateModule, ButtonModule],
})
export class AccountNoCompaniesComponent {
    private readonly authService = inject(MsalService);

    public logout(): void {
        this.authService.logoutRedirect();
    }
}
